import { Box } from "@mui/material"
import { HistoryList } from "components/History/HistoryList"
import { History } from "graphql/types"
import { useState } from "react"

export const AudittrailTab = () => {
  const [history] = useState<History[]>([])

  return (
    <Box sx={{ p: 2 }}>
      <HistoryList history={history} />
    </Box>
  )
}
